import type { CountryOption } from '../models.js';
import { CLIENT_USER_ROLE, LOCAL_CLIENT_VIEW_ROLE, REPORTING_ROLE, type Role } from './roles.js';

const COUNTRY_RESTRICTED_ROLES: readonly Role[] = [CLIENT_USER_ROLE, LOCAL_CLIENT_VIEW_ROLE];

export const hasReportingRole = (user: { roleKeys?: readonly Role[] } | undefined): boolean =>
  user?.roleKeys?.includes(REPORTING_ROLE) ?? false;

export const filterCountriesForUser = (
  options: CountryOption[],
  user: { roleKeys: Role[]; countryCodes: string[] },
): CountryOption[] =>
  user.roleKeys.some((role) => COUNTRY_RESTRICTED_ROLES.includes(role))
    ? options.filter((option) => user.countryCodes.includes(option.value))
    : options;
